import { createEventBus as e } from "@magnopus-opensource/magnopus-web-common";
//#region src/lib/services/olympus/mock.olympus.client.ts
var t = {
	position: [
		0,
		0,
		0
	],
	rotation: [
		0,
		0,
		0,
		1
	],
	scale: [
		1,
		1,
		1
	]
}, n = [
	{
		...t,
		_keys: [],
		id: BigInt(0),
		isInternalComponent: () => !1,
		type: "AnimatedModel"
	},
	{
		...t,
		_keys: [],
		id: BigInt(1),
		isInternalComponent: () => !1,
		type: "StaticModel"
	},
	{
		...t,
		_keys: [],
		id: BigInt(2),
		isInternalComponent: () => !1,
		type: "Audio"
	},
	{
		...t,
		_keys: [],
		id: BigInt(3),
		isInternalComponent: () => !1,
		type: "Video"
	},
	{
		...t,
		_keys: [],
		id: BigInt(4),
		isInternalComponent: () => !1,
		type: "Button"
	},
	{
		...t,
		_keys: [],
		id: BigInt(5),
		isInternalComponent: () => !1,
		type: "Collision"
	},
	{
		...t,
		_keys: [],
		id: BigInt(6),
		isInternalComponent: () => !1,
		type: "Light"
	}
], r = (t) => n.map((n) => ({
	...n,
	parentId: t.id,
	parent: t,
	getUniqueId: () => `${t.id}:${n.id}`,
	events: e()
}));
e();
var i = (t) => {
	let n = {
		name: `Mock Entity ${t}`,
		id: BigInt(t),
		isInternalEntity: () => !1,
		events: e()
	}, i = r(n);
	return n.components = i, n.getComponent = (e) => i[e], n;
}, a = {
	auth: {
		guestLogin: function() {
			throw Error("Function not implemented.");
		},
		login: function(e, t, n) {
			throw Error("Function not implemented.");
		},
		logout: function() {
			throw Error("Function not implemented.");
		},
		rememberMe: function(e) {
			throw Error("Function not implemented.");
		},
		restore: function(e) {
			throw Error("Function not implemented.");
		},
		startOAuthLogin: function(e, t) {
			throw Error("Function not implemented.");
		},
		restoreOAuthLogin: function(e, t, n) {
			throw Error("Function not implemented.");
		}
	},
	users: {
		ping: function() {
			throw Error("Function not implemented.");
		},
		getUserId: function() {
			return "mockid";
		},
		get: function(e) {
			throw Error("Function not implemented.");
		},
		find: function(e) {
			throw Error("Function not implemented.");
		},
		getCurrentUserProfile: function(e) {
			throw Error("Function not implemented.");
		},
		settings: {
			get: function() {
				throw Error("Function not implemented.");
			},
			update: function(e) {
				throw Error("Function not implemented.");
			},
			getByContext: function(e, t, n) {
				throw Error("Function not implemented.");
			},
			getByContextAnonymous: function(e, t, n, r) {
				throw Error("Function not implemented.");
			}
		},
		register: function(e, t, n, r, i, a) {
			throw Error("Function not implemented.");
		},
		updateDisplayName: function(e, t) {
			throw Error("Function not implemented.");
		},
		forgotPassword: function(e) {
			throw Error("Function not implemented.");
		},
		resetPassword: function(e, t) {
			throw Error("Function not implemented.");
		},
		deleteUser: function(e) {
			throw Error("Function not implemented.");
		},
		updateAvatarPortrait: function(e, t) {
			throw Error("Function not implemented.");
		},
		getAvatarPortrait: function(e) {
			throw Error("Function not implemented.");
		},
		updateAvatarSettings: function(e, t, n) {
			throw Error("Function not implemented.");
		},
		getAvatarSettings: function() {
			throw Error("Function not implemented.");
		},
		getCheckoutPortalUrl: function(e) {
			throw Error("Function not implemented.");
		},
		getCheckoutSessionUrl: function(e) {
			throw Error("Function not implemented.");
		},
		resendUserAccountVerification: function(e) {
			throw Error("Function not implemented.");
		}
	},
	spaceEntities: {
		getEntity: (e) => i(e),
		getAllEntities: () => Array.from(Array(10).keys()).map((e) => i(e))
	},
	spaces: {
		recentlyVisited: function() {
			throw Error("Function not implemented.");
		},
		get: function(e) {
			throw Error("Function not implemented.");
		},
		getCurrentSpace: function() {
			throw Error("Function not implemented.");
		},
		findReportedSpaces: function() {
			throw Error("Function not implemented.");
		},
		findReportedUsers: function() {
			throw Error("Function not implemented.");
		},
		findByIds: function(e) {
			throw Error("Function not implemented.");
		},
		setVisited: function(e) {
			throw Error("Function not implemented.");
		},
		create: function(e) {
			throw Error("Function not implemented.");
		},
		enter: function({ id: e, asGuest: t, needUpdate: n }) {
			throw Error("Function not implemented.");
		},
		exit: function() {
			throw Error("Function not implemented.");
		},
		leave: function(e) {
			throw Error("Function not implemented.");
		},
		update: function(e, t) {
			throw Error("Function not implemented.");
		},
		updateSpaceMetadata: function(e, t) {
			throw Error("Function not implemented.");
		},
		delete: function(e) {
			throw Error("Function not implemented.");
		},
		reportSpace: function(e) {
			throw Error("Function not implemented.");
		},
		unblockSpace: function(e) {
			throw Error("Function not implemented.");
		},
		blockUser: function(e, t) {
			throw Error("Function not implemented.");
		},
		inviteUser: function(e, t, n) {
			throw Error("Function not implemented.");
		},
		removeUser: function(e, t) {
			throw Error("Function not implemented.");
		},
		unblockUser: function(e, t) {
			throw Error("Function not implemented.");
		},
		getSpaceRoles: function(e) {
			throw Error("Function not implemented.");
		},
		updateUserRole: function(e, t) {
			throw Error("Function not implemented.");
		},
		updateSpaceThumbnail: function(e, t) {
			throw Error("Function not implemented.");
		},
		getSpaceThumbnail: function(e) {
			throw Error("Function not implemented.");
		},
		getSpaceUsingGraphQL: function(e) {
			throw Error("Function not implemented.");
		},
		createSpaceInstance: function(e, t, n, r, i) {
			throw Error("Function not implemented.");
		},
		updateSpaceTags: function(e, t) {
			throw Error("Function not implemented.");
		}
	},
	assets: {
		get: function(e) {
			throw Error("Function not implemented.");
		},
		find: function(e) {
			throw Error("Function not implemented.");
		},
		findAssetPacks: function() {
			throw Error("Function not implemented.");
		},
		update: function(e) {
			throw Error("Function not implemented.");
		},
		delete: function(e) {
			throw Error("Function not implemented.");
		},
		getDetailsForCollection: function(e) {
			throw Error("Function not implemented.");
		},
		getLODsForCollection: function(e) {
			throw Error("Function not implemented.");
		},
		getLOD: function(e, t) {
			throw Error("Function not implemented.");
		},
		createLOD: function(e, t) {
			throw Error("Function not implemented.");
		},
		deleteLOD: function(e, t, n) {
			throw Error("Function not implemented.");
		},
		getAssetDetailDataSize: function(e, t) {
			throw Error("Function not implemented.");
		},
		createNewAsset: function(e, t) {
			throw Error("Function not implemented.");
		},
		initEvents: function() {
			throw Error("Function not implemented.");
		},
		stopEvents: function() {
			throw Error("Function not implemented.");
		},
		findForComponent: function(e, t, n, r) {
			throw Error("Function not implemented.");
		},
		getAsset: function(e, t) {
			throw Error("Function not implemented.");
		},
		uploadToExistingAsset: function(e, t) {
			throw Error("Function not implemented.");
		},
		getDetailsForCollections: function(e) {
			throw Error("Function not implemented.");
		},
		getLODsForCollections: function(e) {
			throw Error("Function not implemented.");
		}
	},
	chat: {
		connected: function() {
			throw Error("Function not implemented.");
		},
		connect: function() {
			throw Error("Function not implemented.");
		},
		disconnect: function() {
			throw Error("Function not implemented.");
		},
		sendChatMessage: function(e) {
			throw Error("Function not implemented.");
		}
	},
	geolocation: {
		get: function(e) {
			throw Error("Function not implemented.");
		},
		create: function(e, t) {
			throw Error("Function not implemented.");
		},
		update: function(e, t) {
			throw Error("Function not implemented.");
		},
		delete: function(e) {
			throw Error("Function not implemented.");
		},
		hasGeolocation: function(e) {
			throw Error("Function not implemented.");
		}
	},
	quota: {
		getTotalSpacesOwnedByUser: () => {
			throw Error("Function not implemented.");
		},
		getConcurrentUsersInSpace: (e) => {
			throw Error("Function not implemented.");
		},
		getTotalSpaceSizeInKilobytes: (e) => {
			throw Error("Function not implemented.");
		},
		getCurrentUserPricingTier: () => {
			throw Error("Function not implemented.");
		},
		getAvailablePricingFeaturesForUser: () => {
			throw Error("Function not implemented.");
		},
		isTierPurchasable: (e) => {
			throw Error("Function not implemented.");
		},
		isTierUpgradable: (e) => {
			throw Error("Function not implemented.");
		},
		getAllTierInformation: () => {
			throw Error("Function not implemented.");
		},
		getTierInformation: (e) => {
			throw Error("Function not implemented.");
		}
	},
	externalServiceProxy: {
		getAgoraUserToken: function(e, t, n) {
			throw Error("Function not implemented.");
		},
		invokeOperation: function(e, t, n) {
			throw Error("Function not implemented.");
		}
	},
	destroy: function() {
		throw Error("Function not implemented.");
	},
	loadAssetDetails: function(e) {
		throw Error("Function not implemented.");
	},
	internalEvents: e()
};
//#endregion
export { a as mockOlympusClient };
